export const timeZone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
};
